export default __webpack_public_path__ + "static/heroku-94d980b20067734b343945772b920262.png";